import React from "react";
import { Moon } from "lucide-react";

/**
 * Modal die agents kort bevestigt voordat ze één of meerdere panden op rust
 * zetten. Auto-resurrect: zodra Supabase het pand opnieuw online toont,
 * komt het automatisch terug in de juiste pipeline met alle historie.
 */
export default function BulkArchiveDialog({ sel }) {
  const ids = sel.archiveIds;
  if (!ids) return null;
  const isOne = ids.length === 1;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4"
         data-testid="bulk-archive-modal"
         onClick={sel.cancelArchive}>
      <div onClick={(e) => e.stopPropagation()}
           className="bg-white rounded-xl shadow-2xl w-full max-w-md p-6">
        <div className="flex items-center gap-2 mb-1">
          <Moon size={18} className="text-[var(--teal-700)]" />
          <h3 className="font-display text-[20px] text-[var(--ink-900)]">
            {isOne ? "Pand op rust zetten" : `${ids.length} panden op rust zetten`}
          </h3>
        </div>
        <p className="text-[13px] text-[var(--ink-500)] mb-5">
          {isOne
            ? "Het pand verdwijnt uit de overzichten en komt op de \"Op rust\"-lijst. Al je werk blijft bewaard. Komt het pand opnieuw online in Supabase, dan plaatst FlowNavigator de lead automatisch terug in de juiste pipeline."
            : "Deze panden verdwijnen uit de overzichten en komen op de \"Op rust\"-lijst. Al je werk blijft bewaard. Komen ze opnieuw online in Supabase, dan plaatst FlowNavigator ze automatisch terug in de juiste pipeline."}
        </p>
        <div className="flex justify-end gap-2">
          <button type="button"
                  onClick={sel.cancelArchive}
                  className="btn btn-ghost !h-9 !px-4 !text-[13px]">
            Annuleren
          </button>
          <button type="button"
                  onClick={sel.doArchive}
                  data-testid="bulk-archive-confirm"
                  className="btn btn-primary !h-9 !px-4 !text-[13px]">
            <Moon size={13} /> {isOne ? "Op rust zetten" : `${ids.length} op rust zetten`}
          </button>
        </div>
      </div>
    </div>
  );
}
